import { ChangeEvent, FormEvent, useState } from "react";
import GeneralInput from "../../common/GeneralInput";
import Modal from "../../common/Modal";
import { Subzone } from "../../../types/common.types";
import { useAdmin } from "../../../context/admin";
import { AiOutlineCloseCircle } from "react-icons/ai";
import AdminService from "../../../services/admin.service";
import Checkbox from "../../common/Checkbox";
import FileInput from "../../common/FileInput";
import jsonToFormData from "../../../utils/jsonToFormData";
import { useGlobal } from "../../../context/global";
import convertToWebP from "../../../utils/convertToWebP";

export default function CreateSubzone() {
    const { setIsCreateSubzoneModalOpen, subzonesZone } = useAdmin()
    const { setIsLoading, setMessage } = useGlobal()
    const [data, setData] = useState<Partial<Subzone>>({
        id: '',
        navbar: false,
        orden: 0,
    } as Subzone)

    async function submit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            let processedData: Partial<Subzone> = { ...data, zone_id: subzonesZone }
            if (processedData.cover instanceof File) {
                try { processedData.cover = await convertToWebP(processedData.cover) }
                catch (err) { console.error('WebP error:', err) }
            }
            const formData = jsonToFormData(processedData)
            await AdminService.registerSubzone(formData)
            window.location.reload()
        } catch (error) {
            console.log(error);
            setMessage({ type: 'error', content: 'Error creating subzone' });
            setTimeout(() => setMessage(undefined), 2500);
        } finally {
            setIsLoading(false);
        }
    }

    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const { name, value } = e.target
        setData(prev => ({ ...prev, [name]: value }))
    }

    const handleFileChange = async (newFile: File) => {
        try {
            setIsLoading(true);
            const webpFile = await convertToWebP(newFile);
            setData(prev => ({ ...prev, cover: webpFile }));
        } catch (error) {
            setData(prev => ({ ...prev, cover: newFile }));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal onSubmit={submit}>
            <h1>Create subzone</h1>
            <p style={{ marginTop: 0, fontSize: 13, color: '#777' }}>Zona: <strong>{subzonesZone}</strong></p>
            <div className="input-container">
                <Checkbox checked={data.navbar} label="Show in navbar"
                onChange={(checked: boolean) => setData(prev => ({ ...prev, navbar: checked }))} />
            </div>
            <div className="input-container">
                <GeneralInput name="id" label="ID (slug, ej: san-pedro-privado)" value={data.id} onChange={onChange} />
            </div>
            <div className="input-container">
                <GeneralInput name="nombre" label="Nombre (es)" value={data.nombre || ''} onChange={onChange} />
                <GeneralInput name="nombre_en" label="Nombre (en)" value={data.nombre_en || ''} onChange={onChange} />
                <GeneralInput name="nombre_pt" label="Nombre (pt)" value={data.nombre_pt || ''} onChange={onChange} />
            </div>
            <div className="input-container">
                <FileInput value={data.cover} style={{ height: '100px' }}
                label="Cover (will be converted to WebP)" accept=".png, .jpg, .jpeg, .heic, .webp"
                onChange={handleFileChange}
                deleteFile={() => setData(prev => { const { cover, ...rest } = prev; return rest; })} />
            </div>
            <div className="input-container">
                <GeneralInput name="overview" label="Overview (en)" value={data.overview || ''} onChange={onChange} />
                <GeneralInput name="overview_es" label="Overview (es)" value={data.overview_es || ''} onChange={onChange} />
                <GeneralInput name="overview_pt" label="Overview (pt)" value={data.overview_pt || ''} onChange={onChange} />
            </div>
            <div className="input-container">
                <GeneralInput name="description" label="Description (en)" value={data.description || ''} onChange={onChange} />
                <GeneralInput name="description_es" label="Description (es)" value={data.description_es || ''} onChange={onChange} />
                <GeneralInput name="description_pt" label="Description (pt)" value={data.description_pt || ''} onChange={onChange} />
            </div>
            <div className="input-container">
                <GeneralInput name="orden" label="Orden (0,1,2...)" value={(data.orden ?? 0).toString()} onChange={onChange} />
            </div>
            <div className="actions" style={{ marginTop: '20px' }}>
                <button type="submit">Submit</button>
            </div>
            <div className="close" title="close" onClick={() => setIsCreateSubzoneModalOpen(false)}>
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}
